// extracted by mini-css-extract-plugin
export var breadcrumb = "style-module--breadcrumb--6aa04";
export var category = "style-module--category--c812b";
export var container = "style-module--container--9eb61";
export var separator = "style-module--separator--d9616";
export var title = "style-module--title--64537";